import { addDays, differenceInDays, format, subYears } from 'date-fns';
var generateMockExtendedWorkHours = function () {
    var endDate = new Date();
    var startDate = subYears(endDate, 1);
    var totalDays = differenceInDays(endDate, startDate) + 1;
    var workHoursPatterns = [
        { weight: 40, hours: [6, 7, 8] },
        { weight: 30, hours: [4, 5] },
        { weight: 20, hours: [9, 10, 11] },
        { weight: 10, hours: [12, 13, 14] }
    ];
    var getRandomHours = function () {
        var random = Math.random() * 100;
        var cumulativeWeight = 0;
        for (var _i = 0, workHoursPatterns_1 = workHoursPatterns; _i < workHoursPatterns_1.length; _i++) {
            var pattern = workHoursPatterns_1[_i];
            cumulativeWeight += pattern.weight;
            if (random <= cumulativeWeight) {
                return pattern.hours[Math.floor(Math.random() * pattern.hours.length)];
            }
        }
        return 7;
    };
    return Array.from({ length: totalDays }, function (_, i) {
        var currentDate = addDays(startDate, i);
        var dayOfWeek = currentDate.getDay();
        var isWeekend = dayOfWeek === 0 || dayOfWeek === 6;
        var shouldSkip = isWeekend && Math.random() > 0.3;
        if (shouldSkip) {
            return null;
        }
        return {
            date: format(currentDate, 'yyyy-MM-dd'),
            count: getRandomHours()
        };
    }).filter(function (day) { return day !== null; });
};
export var daysWithExtendedWorkHours = function (input) {
    return generateMockExtendedWorkHours();
};
